/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import snakeCase from 'lodash/snakeCase';

import { Grid, Link, Typography2 } from '@coursera/cds-core';
import { ArrowNextIcon } from '@coursera/cds-icons';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import { scrollPageToTop } from 'bundles/unified-seo-content-common/utils';

import _t from 'i18n!nls/unified-seo-content-common';

type Props = {
  title: string;
  ctaLink: string;
  ctaLabel?: string;
};

const styles = {
  collectionHeader: css`
    margin-bottom: 24px;
  `,
  viewAllLink: css`
    text-decoration: none !important;

    span {
      color: #1f2022;
    }
  `,
};

export const CollectionHeader = ({ title, ctaLink, ctaLabel = _t('View all') }: Props) => {
  return (
    <Grid css={styles.collectionHeader} container>
      <Grid item xs={9}>
        <Typography2 component="h3" variant="titleSmall">
          {title}
        </Typography2>
      </Grid>
      <Grid item container xs={3} justifyContent="flex-end">
        <Link
          css={styles.viewAllLink}
          component={TrackedLink2}
          href={ctaLink}
          trackingName={`${snakeCase(title)}_cta`}
          icon={<ArrowNextIcon size="small" />}
          iconPosition="after"
          variant="quiet"
          onClick={scrollPageToTop}
        >
          <Typography2 variant="subtitleMedium" component="span">
            {ctaLabel}
          </Typography2>
        </Link>
      </Grid>
    </Grid>
  );
};

export default CollectionHeader;
